export const calculeDiscount = (salePriceVl: number, originalPrice: number) => {
  const perc = salePriceVl / originalPrice
  let discPe = 0
  let discVl = 0
  if (originalPrice !== 0 && originalPrice >= salePriceVl) {
    discPe = (1 - perc) * 100
    discVl = (1 - perc) * originalPrice
  }

  return [discPe, discVl]
}
